import { Injectable } from "@angular/core";
import { SubscribtionClient, Subscribe, AddPremiumAdToken, AddPremiumAdTokenResponse, AddWriteAdToken, AddBaner } from "../api/WickedApiClient";



@Injectable({
  providedIn: "root"
})
export class SubscribtionService {

  constructor(private subscribtionClient: SubscribtionClient) {
  }

  create(subscribe: Subscribe) {
    return this.subscribtionClient.create(subscribe).toPromise();
  }

  cancel(subscribtionId: string) {
    return this.subscribtionClient.cancelSubscribtion(subscribtionId).toPromise();
  }

  hasUserSubscribtion() {
    return this.subscribtionClient.hasUserSubscribtion().toPromise();
  }

  get() {
    return this.subscribtionClient.subscribtionData().toPromise();
  }

  createPremiumAdToken(data: AddPremiumAdToken) {
    return this.subscribtionClient.createPremiumAdToken(data).toPromise();
  }

  GetUserPremiumAdTokens() {
    return this.subscribtionClient.getUserPremiumAdTokens().toPromise();
  }

  createWriteAdToken(data: AddWriteAdToken) {
    return this.subscribtionClient.createWriteAdToken(data).toPromise();
  }

  createThirdPartyAdToken(data: AddWriteAdToken) {
    return this.subscribtionClient.createThirdPartyAdToken(data).toPromise();
  }

  GetUserThirdPartyAdTokens() {
    return this.subscribtionClient.getUserThirdPartyAdTokens().toPromise();
  }

  getWriteAdToken(): Promise<number> {
    return this.subscribtionClient.getWriteAdToken().toPromise();
  }

  //baner
  createBanerAdvertising(data: AddBaner) {
    return this.subscribtionClient.createBanerAdvertising(data).toPromise();
  }
}
